import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { fetchAttachmentSuccess, onGetAttachmentByIdSuccess, onRemoveAttachmentSuccess, onUploadAttachmentSuccess } from "../actions/Attachment";
import { ActionTypes } from "../../constants/ActionTypes";
import { ShowError, ShowSuccess } from "../../helper/Alert";
import { IUploadAttachment } from "../../interfaces";
import faMessage from "../../../src/lngProvider/locales/fa_IR.json";
import enMessage from "../../../src/lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

// recent attachment
const getAttachment = async (letterCode: string) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`letterAttach/getLetterAttach?letterCode=${letterCode}`);
}

function* fetchAttachmentRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedAttachment = yield call(getAttachment, action.letterCode);
        yield put(fetchAttachmentSuccess(fetchedAttachment.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchAttachment() {
    yield takeEvery(ActionTypes.GET_Attachment, fetchAttachmentRequest);
}

const uploadAttachmentApi = async (uploadAttachmentModel: IUploadAttachment) => {
    const fd = new FormData();
    fd.append("file", uploadAttachmentModel.file);
    let http = await FaraGostarDynamicHttp();
    return await http.post(`letterAttach/UploadLetterAttachment?letterCode=${uploadAttachmentModel.letterCode}`,
        fd, {
        headers: {
            "content-type": "multipart/form-data",
        }
    });
}

function* uploadAttachmentRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        let attachmentId = yield call(uploadAttachmentApi, action.uploadAttachmentModel);
        if (attachmentId.data == null) {
            ShowError(messages["messages.AttachUpLoading"], messages["messages.errorOccurInUploading"]);
            return;
        }
        yield put(onUploadAttachmentSuccess(attachmentId.data, action.uploadAttachmentModel.file.name));
        ShowSuccess(messages["messages.AttachUpLoading"], messages["messages.UploadIsSuccessfully"]);
    } catch (error) {
        return ShowError("", error);
    }
}

export function* uploadAttachment() {
    yield takeEvery(ActionTypes.UPLOAD_ATTACHMENT, uploadAttachmentRequest);
}

const removeAttachmentApi = async (letterCode: string, letterAttachmentId: number) => {
    let http = await FaraGostarDynamicHttp();

    return await http.post(`letterAttach/DeleteLetterAttachment`,
        {
            letterCode: letterCode,
            letterAttachmentId: letterAttachmentId
        });
}

function* removeAttachmentRequest(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        yield call(removeAttachmentApi, action.payload.letterCode, action.payload.letterAttachmentId);
        yield put(onRemoveAttachmentSuccess(action.payload.letterAttachmentId, action.payload.fileName));
        ShowSuccess(messages["messages.removeAttachment"], messages["messages.AttachmentDeleteSuccessfully"]);
    } catch (error) {
        return ShowError("", error);
    }
}

export function* removeAttachment() {
    yield takeEvery(ActionTypes.REMOVE_ATTACHMENT, removeAttachmentRequest);
}

const downloadAttachmentApi = async (letterCode: string, letterAttachmentId: number) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`letterAttach/GetAttachFile?letterCode=${letterCode}&attachId=${letterAttachmentId}`, { responseType: "blob" });
}

function* downloadAttachmentRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        let result = yield call(downloadAttachmentApi, action.payload.letterCode, action.payload.attachmentId);
        yield put(onGetAttachmentByIdSuccess(result));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* downloadAttachment() {
    yield takeEvery(ActionTypes.GET_Attachment_BY_ID, downloadAttachmentRequest);
}

export default function* rootSaga() {
    yield all([fork(fetchAttachment), fork(uploadAttachment), fork(removeAttachment), fork(downloadAttachment)]);
}
